/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './header.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../../app/modules/layout/components/header/header.component';
import * as i4 from '../../../../../../app/modules/user/services/auth/auth.service';
import * as i5 from '../../../../../../app/modules/user/services/current-user/current-user.service';
const styles_HeaderComponent:any[] = [i0.styles];
export const RenderType_HeaderComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HeaderComponent,data:{}});
function View_HeaderComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(0,(null as any),[', ','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.user.email;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_HeaderComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(1,0,
      (null as any),(null as any),6,'div',[['class','right']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵeld(3,0,(null as any),(null as any),3,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['Welcome'])),(_l()(),i1.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_HeaderComponent_1)),i1.ɵdid(6,16384,(null as any),
      0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n\n']))],
      (_ck,_v) => {
        var _co:i3.HeaderComponent = _v.component;
        const currVal_0:any = _co.user;
        _ck(_v,6,0,currVal_0);
      },(null as any));
}
export function View_HeaderComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-header',
      ([] as any[]),(null as any),(null as any),(null as any),View_HeaderComponent_0,
      RenderType_HeaderComponent)),i1.ɵdid(1,114688,(null as any),0,i3.HeaderComponent,
      [i4.AuthService,i5.CurrentUserService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HeaderComponentNgFactory:i1.ComponentFactory<i3.HeaderComponent> = i1.ɵccf('app-header',
    i3.HeaderComponent,View_HeaderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2xheW91dC9jb21wb25lbnRzL2hlYWRlci9oZWFkZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2xheW91dC9jb21wb25lbnRzL2hlYWRlci9oZWFkZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9kbmF0YS1jZXJmLWZyb250LWVuZC9yZWxlYXNlcy8yMDIwMDMyNjE2MTIzMy9zcmMvYXBwL21vZHVsZXMvbGF5b3V0L2NvbXBvbmVudHMvaGVhZGVyL2hlYWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2xheW91dC9jb21wb25lbnRzL2hlYWRlci9oZWFkZXIuY29tcG9uZW50LnRzLkhlYWRlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuPGRpdiBjbGFzcz1cInJpZ2h0XCI+XG4gIDxzcGFuPldlbGNvbWU8bmctdGVtcGxhdGUgW25nSWZdPVwidXNlclwiPiwge3t1c2VyLmVtYWlsfX08L25nLXRlbXBsYXRlPjwvc3Bhbj5cbjwvZGl2PlxuXG4iLCI8YXBwLWhlYWRlcj48L2FwcC1oZWFkZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0UwQzs7O0lBQUE7SUFBQTs7OztvQkFGMUMsMENBQ0E7TUFBQTtNQUFBLDRDQUFtQjtNQUFBLFdBQ2pCO01BQUEsd0VBQU07YUFBQSxnQ0FBTztNQUFBLDhEQUFBO01BQUE7TUFBZ0UsMENBQ3pFOzs7UUFEc0I7UUFBYixXQUFhLFNBQWI7Ozs7b0JDRmY7TUFBQTtnQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/layout/components/header/header.component.ngfactory.ts